import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ingestion Service API
export const ingestionAPI = {
  triggerRSS: () => api.post('/api/ingestion/trigger'),
  uploadEpaper: (formData, config) => api.post('/api/epaper/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...config
  }),
  getArticles: (params) => api.get('/api/ingestion/articles', { params }),
  getRSSScanHistory: () => api.get('/api/ingestion/rss-history'),
  getEpaperUploadHistory: () => api.get('/api/epaper/upload-history'),
};

// Judge Agent API
export const judgeAPI = {
  getScoredArticles: () => api.get('/api/judge/scored-articles'),
  getStats: () => api.get('/api/judge/stats'),
  getHealth: () => api.get('/api/judge/../health'),
  getEpaperDates: (days = 7) => api.get(`/api/judge/epaper-dates?days=${days}`),
  getEpaperArticlesByDate: (date, skip = 0, limit = 100) =>
    api.get(`/api/judge/epaper-articles?date=${encodeURIComponent(date)}&skip=${skip}&limit=${limit}`),
};

// Question Architect API
export const architectAPI = {
  getPendingQuestions: (params) => api.get('/api/architect/pending', { params }),
  getApprovedQuestions: (params) => api.get('/api/architect/approved', { params }),
  approveQuestions: (data) => api.post('/api/architect/approve', data),
  rejectQuestions: (data) => api.post('/api/architect/reject', data),
  getStats: () => api.get('/api/architect/stats'),
  getHealth: () => api.get('/api/architect/../health'),
};

// PYQ Upload API (custom endpoint for dashboard)
export const pyqAPI = {
  upload: (formData) => api.post('/api/ingestion/upload-pyq', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  listPYQs: () => api.get('/api/ingestion/pyqs'),
  getPYQStats: () => api.get('/api/ingestion/pyq-stats'),
};

// MongoDB Direct queries (via custom endpoint if needed)
export const dataAPI = {
  getScoredArticles: (params) => api.get('/api/ingestion/scored-articles', { params }),
  getArticleById: (id) => api.get(`/api/ingestion/articles/${id}`),
};

export default api;
